<template>
    <v-container class="pa-0">
        <v-card
            class="ma-0"
            width="100%"
            flat
            height="83vh"
        >
            <div class="wrapper-ticket">
                <v-row>
                    <v-col md="4" class="py-4">
                        <TicketList 
                            @isFilterDrawerVisible="isFilterDrawerVisible"
                            :selectedDepartmentIdFilter="selectedDepartmentIdFilter"
                            :selectedStatusId="selectedStatus"
                            :selectedFromDate="selectedFromDate"
                            :selectedToDate="selectedToDate"
                            :isFiltersApply="isFiltersApply"
                            :isFiltersRemove="isFiltersRemove"
                            @ticketSelection="ticketSelectionHandler"
                            @onSelectTicket="onSelectTicketHandler"
                            @createNewTicket="createNewTicketHandler"
                            :newTicket="newTicket"
                            :closedTicketId="closedTicketId"
                            @onToggleTicketSelection="onToggleTicketSelection"
                        />
                    </v-col>
                    <v-col md="8" class="py-4">
                        <TicketMessage 
                            :isTicketSelected="isTicketSelected"
                            :selectedTicket="selectedTicket"
                            :isCreateNewTicket="isCreateNewTicket"
                            @addTickets="addTicketsHandler"
                            @closeTicket="closeTicket"
                            :toggleSelectionTicket="toggleSelectionTicket"
                        />
                    </v-col>
                </v-row>
            </div>
        </v-card>

        <v-navigation-drawer
            v-model="filterDrawerVisibility"
            absolute
            temporary
            width="350"
            class="ticket-drawer"
        >
            <v-container class="pa-0">
                <v-container class="d-flex justify-space-between pa-5">
                    <v-card-text class="pa-0">{{ $t("filter") }}</v-card-text>
                    <v-icon 
                        style="cursor: pointer;"
                        @click="filterDrawerVisibility = !filterDrawerVisibility"
                    >
                    mdi-close
                    </v-icon>
                </v-container>
                <v-list-item class="mb-2">
                    <autocomplete
                        v-model="department"
                        :title="$t('departments')"
                        type="departments"
                        :value="department"
                        class="flex-fill"
                        @clear="clearFilters('department')"
                    />
                </v-list-item>
                <v-list-item class="mb-2">
                    <autocomplete
                        v-model="status"
                        :title="$t('status')"
                        type="ticketStatus"
                        :value="status"
                        class="flex-fill"
                        @clear="clearFilters('status')"
                    />
                </v-list-item>
                <v-card-text class="pb-0 pt-5 text-body-1">{{ $t('choose date') }}</v-card-text>
                <v-list-item class="mb-2">
                    <template>
                        <v-text-field
                            id="fromDate"
                            v-model="selectedFromDate"
                            :label="$t('fromDate')"
                            append-icon="mdi-calendar"
                            outlined
                            dense
                            clearable
                        />
                        <date-picker
                            v-model="selectedFromDate"
                            element="fromDate"
                            format="jYYYY/jMM/jDD"
                        />
                    </template>
                </v-list-item>
                <v-list-item class="mb-2">
                    <v-text-field
                        id="toDate"
                        v-model="selectedToDate"
                        :label="$t('toDate')"
                        append-icon="mdi-calendar"
                        outlined
                        dense
                        clearable
                    />
                    <date-picker
                        v-model="selectedToDate"
                        element="toDate"
                        format="jYYYY/jMM/jDD"
                    />
                </v-list-item>
            </v-container>
            
            <v-container 
                class="d-flex justify-end align-end px-5 gap-2" 
                style="flex-grow: 1;"
            >
                <v-btn
                    custom
                    color='primary'
                    class="flex-fill"
                    @click="applyFilter"
                >
                    <span>{{ $t("apply filters") }}</span>
                </v-btn>
                <v-btn
                    custom
                    outlined
                    class="flex-fill"
                    @click="removeFilter"
                >
                    <span>{{ $t("delete filters") }}</span>
                </v-btn>
            </v-container>
        </v-navigation-drawer>
    </v-container>
</template>

<script>
import TicketDepartment from '@/views/dashboard/pages/ticket/partial/TicketDepartments.vue'
import TicketList from '@/views/dashboard/pages/ticket/partial/TicketList.vue'
import TicketMessage from "@/views/dashboard/pages/ticket/partial/TicketMessage.vue"

export default {
  name: 'App',
  data() {
    return {
        filterDrawerVisibility: false,
        status: null,
        departments: null,
        selectedStatus: null,
        isFiltersApply: false,
        isFiltersRemove: false,
        isTicketSelected: false,
        selectedTicket: null,
        isCreateNewTicket: false,
        newTicket: null,
        selectedFromDate: null,
        selectedToDate: null,
        closedTicketId: null,
        department: null,
        selectedDepartmentIdFilter: null,
        toggleSelectionTicket: false
    }
  },
  components: {
    TicketDepartment,
    TicketList,
    TicketMessage
  },
  methods: {
    isFilterDrawerVisible() {
        this.filterDrawerVisibility = !this.filterDrawerVisibility
    },
    applyFilter() {
        this.isFiltersApply = !this.isFiltersApply
        this.filterDrawerVisibility = false
    },
    removeFilter() {
        this.isFiltersRemove = !this.isFiltersRemove
        this.department = null
        this.selectedDepartmentIdFilter = null
        this.status = null
        this.selectedStatus = null
        this.selectedFromDate = null
        this.selectedToDate = null
        this.filterDrawerVisibility = false
    },
    ticketSelectionHandler(value) {
        this.isTicketSelected = value
    },
    onToggleTicketSelection(val) {
        this.toggleSelectionTicket = val
    },
    onSelectTicketHandler(value) {
        this.selectedTicket = value
    },
    createNewTicketHandler() {
        this.isCreateNewTicket = !this.isCreateNewTicket
    },
    addTicketsHandler(value) {
        this.newTicket = value
    },
    closeTicket(value) {
        this.closedTicketId = value
    },
    clearFilters(value) {
        if(value == 'department') {
            this.selectedDepartmentIdFilter = null
        } 
        if(value == 'status') {
            this.selectedStatus = null
        }
    }
  },
  watch: {
    department(val) {
        if(val) {
            this.selectedDepartmentIdFilter = val.id
        }
    },
    status(val) {
        if(val) {
           this.selectedStatus = val.id 
        }
    }
  }
}
</script>

<style>
.wrapper-ticket {
    height: 100%;
    padding: 16px;
}
.wrapper-ticket .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
  margin: 0;
  padding: 12px;
  border-radius: 12px;
  width: 100%;
  border: 1px solid #999999;
  height: 64px;
}
.wrapper-ticket .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}
.ticket-drawer,
.ticket-drawer .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
}
/** global for ticket **/
.v-card .v-divider {
    border-color: rgba(192, 192, 192, 0.765) !important;
}
.v-divider--vertical.v-divider--inset {
    margin-top: 0 !important;
}
.v-card--link:before {
    background: transparent !important;
}
.v-menu__content::-webkit-scrollbar {
    width: 4.5px;
    background-color: silver !important;
}
.v-menu__content::-webkit-scrollbar-track {
    background-color: rgba(189, 189, 189, 0.769);
    border: none !important;
}
.v-menu__content::-webkit-scrollbar-thumb {
    background-color: rgba(105, 101, 101, 0.767) !important;
    border: none !important;
}
/* .v-navigation-drawer .v-icon.v-icon {
    font-size: 20px !important;
} */
</style>